<template>
  <div class="goods-swip-wrapper">
    <div class="ads-wrapper">
      <div class="goods-type-title">
        <div class="goods-type-title-left">
          <div class="left-title">{{ title }}</div>
          <div class="right-sub">{{ subTitle }}</div>
        </div>
        <div class="goods-type-title-right" @click="gotoMore">
          <span>更多</span
          ><img src="../../../assets//images/right.png" alt="" />
        </div>
      </div>
      <div class="swiper">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item, index) in list" :key="index">
            <div class="goods-item" @click="gotoPage(item)">

              <div class="img">
                <img :src="item.thumbnail || item.imgUrl" :atl="item.name || item.title" />
              </div>
              <div class="item-content-footer" :style="{background: isShowBg ? '#f8ebe4' : ''}">
                <div class="tit">{{ item.name || item.title }}</div>
                <div class="pri">
                  <span class="pri-1">￥{{ item.mktprice }}</span
                  ><span class="pri-2">会员价</span
                  ><span class="pri-3">￥{{ item.price }}</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev">
          </div>
          <div class="swiper-button-next" slot="button-next">
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import bannerType from "./title";

export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: String,
    subTitle: String,
    url: String,
    isShowBg: Boolean,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      showSwiper: false,
    };
  },
  components: {
    bannerType,
    swiper,
    swiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  created() {
  },
  mounted() {
    this.swiper.slideTo(0, 1000, false);
  },
  methods: {
    gotoMore() {
      let text = this.$router.resolve({
        path: this.url,
      });
      window.open(text.href, "_blank");
    },
    gotoPage(item) {
      let text = this.$router.resolve({
        path: `/goods?goods_id=${item.goodsId}`,
      });
      window.open(text.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/home-page/banner-square/goodsList.less";
.goods-swip-wrapper {
  margin-bottom: 107px;
}
.goods-type-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 54px;
  .goods-type-title-left {
    display: flex;
    align-items: baseline;
    .left-title {
      font-size: 35px;
      color: #333333;
      margin-right: 20px;
    }
    .right-sub {
      font-size: 18px;
      color: #858585;
    }
  }
  .goods-type-title-right {
    display: flex;
    align-items: center;
    cursor: pointer;
    span {
      color: #858585;
      font-size: 18px;
      margin-right: 10px;
    }
    img {
      width: 12px;
      height: 23px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// goodsList.vue?10367040